module.exports = __webpack_public_path__ + "img/MeetingRoom.71304147.jpg";